import type { PlanDto } from '@/lib/api';

export type PlanBillingCycle = 'mensal' | 'trimestral' | 'anual';

/** Ciclo pré-selecionado nos cards de plano. */
export const DEFAULT_PLAN_BILLING_CYCLE: PlanBillingCycle = 'anual';

export const PLAN_BILLING_CYCLE_OPTIONS: { value: PlanBillingCycle; label: string }[] = [
  { value: 'anual', label: 'Anual' },
  { value: 'trimestral', label: 'Trimestral' },
  { value: 'mensal', label: 'Mensal' },
];

export type PlanPriceBreakdown = {
  monthlyDisplay: number;
  originalMonthly: number;
  discountPct: number;
  totalPeriod: number;
  months: number;
  cycleLabel: string;
  isFree: boolean;
};

export function planPriceBreakdown(plan: PlanDto, cycle: PlanBillingCycle): PlanPriceBreakdown {
  const monthly = plan.value;
  if (monthly <= 0) {
    return {
      monthlyDisplay: 0,
      originalMonthly: 0,
      discountPct: 0,
      totalPeriod: 0,
      months: 1,
      cycleLabel: 'Grátis',
      isFree: true,
    };
  }

  let discountPct = 0;
  let months = 1;
  let cycleLabel = 'mês';

  if (cycle === 'trimestral') {
    discountPct = plan.qtrDiscount ?? 0;
    months = 3;
    cycleLabel = 'trimestre';
  } else if (cycle === 'anual') {
    discountPct = plan.yearlyDiscount ?? 0;
    months = 12;
    cycleLabel = 'ano';
  }

  const originalMonthly = monthly;
  const monthlyDisplay = discountPct > 0 ? monthly * (1 - discountPct / 100) : monthly;
  const totalPeriod = monthlyDisplay * months;

  return {
    monthlyDisplay,
    originalMonthly,
    discountPct,
    totalPeriod,
    months,
    cycleLabel,
    isFree: false,
  };
}

export function formatPlanCurrency(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
